import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Card, Table, Badge, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

// Components
import LoadingSpinner from '../../utils/LoadingSpinner';
import ConfirmDialog from '../../utils/ConfirmDialog';

// Actions
import { get_worker_instance_events, reset_worker_instance_events } from '../../../actions/workerInstanceActions';

const EVENT_TYPES = {
	0: { label: 'None', color: 'secondary' },
	1: { label: 'Start', color: 'success' },
	2: { label: 'Stop', color: 'primary' },
	3: { label: 'End', color: 'danger' }
};

const WorkerInstEvents = () => {
	const { instance_id } = useParams();

	const dispatch = useDispatch();

	const { worker_instance_events_loading, worker_instance_events } = useSelector(state => state.workerInstance);

	const [clearConfirmShow, setClearConfirmShow] = useState(false);

	useEffect(() => {
		dispatch(get_worker_instance_events(instance_id));
	}, []);

	const events = Array.isArray(worker_instance_events.events) ? worker_instance_events.events : [];

	return (
		<>
			<ConfirmDialog
				show={clearConfirmShow}
				onHide={() => setClearConfirmShow(false)}
				title='Clear Pending Events'
				message={`Are you sure you want to clear all ${events.length} pending events?`}
				confirmFunction={() => {
					dispatch(reset_worker_instance_events(instance_id));
					setClearConfirmShow(false);
				}}
			/>

			<Card className='shadow-sm mb-3 card-border'>
				<Card.Body>
					<Card.Title className='text-center' as='h6'>
						Pending Events <Badge bg='secondary' className='ms-2'>{events.length}</Badge>
					</Card.Title>

					<div className='text-end mb-2'>
						<OverlayTrigger placement='bottom' overlay={<Tooltip>Refresh</Tooltip>}>
							<Button type='button' className='jobs-actions me-3'
								onClick={() => dispatch(get_worker_instance_events(instance_id))}
							>
								<i className='bi bi-arrow-clockwise bi-bold fs-5'></i>
							</Button>
						</OverlayTrigger>
						<OverlayTrigger placement='bottom' overlay={<Tooltip>Clear All Events</Tooltip>}>
							<Button type='button' className='jobs-actions'
								onClick={() => setClearConfirmShow(true)}
								disabled={events.length === 0}
							>
								<i className='bi bi-eraser fs-5'></i>
							</Button>
						</OverlayTrigger>
					</div>

					{worker_instance_events_loading
						? <LoadingSpinner loadingMsg='Loading events' />
						: events.length === 0
							? <p className='text-center text-muted'>No pending events</p>
							: <Table hover responsive size='sm'>
								<thead>
									<tr>
										<th>#</th>
										<th>Type</th>
										<th>Data</th>
									</tr>
								</thead>
								<tbody>
									{events.map((event, idx) => {
										const parsed = typeof event === 'string' ? JSON.parse(event) : event;
										const eventType = parsed?.type !== undefined ? parsed.type : '—';
										const typeInfo = EVENT_TYPES[eventType] || { label: `Type ${eventType}`, color: 'secondary' };

										return (
											<tr key={idx}>
												<td>{idx + 1}</td>
												<td><Badge bg={typeInfo.color}>{typeInfo.label}</Badge></td>
												<td><code style={{ fontSize: '0.8rem' }}>{JSON.stringify(parsed)}</code></td>
											</tr>
										);
									})}
								</tbody>
							</Table>
					}
				</Card.Body>
			</Card>
		</>
	);
}

export default WorkerInstEvents;
